import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { DateTime } from 'luxon';
import { Vehicle } from '../interfaces/vehicle.interface';
import { vhcrecord } from '../interfaces/vhcrecord.interface';
import { JobPartscreenDialog } from '../pages/vhcrecord/jobpartscreen/jobpartscreen.dialog';
import { HelperService } from './helper.service';
import { IQWorkOrderData, SupaService } from './supa.service';
import { Part } from '../interfaces/part.interface';

@Injectable({
  providedIn: 'root'
})
export class DmsService {

  constructor(private http: HttpClient, private loadingController: LoadingController, private helper: HelperService, private supa: SupaService) {
  }

  public async getDMS_VEHICLE(vin:string) {
    const loading = await this.loadingController.create({
      message: 'Checking if the vehicle is the DMS',
      spinner: 'bubbles',
      backdropDismiss: true
    });
    await loading.present();

    try {
      let result = await this.http.get<DmsCarApiResult>("https://m.hha.com.sa/ords/hhaapi/osb/cardata/?vin="+vin, {
        headers: {
          Authorization: 'Basic ' + window.btoa('hhaprodrestuser:hhaprodrestpass1')
        }
      }).toPromise();
      loading.dismiss();
      return result;
    } catch (error) {
      loading.dismiss();
      return {items:[]}
    }
  }

  public async sendIqSms(phonenumber: string, message: string) {
    // if (!phonenumber.startsWith('+31')) {
    //   return
    // }
    const loading = await this.loadingController.create({
      message: 'Sending sms',
      spinner: 'bubbles'
    });
    await loading.present();
    await this.http.post('https://rest.messagebird.com/messages', {
      originator: '447775448022',
      recipients: phonenumber.startsWith('+') ? phonenumber : '+' + phonenumber,
      body: message
    }, {
      headers: {
        Authorization: 'AccessKey KBqUZYKWSsd6wIZbrc0F0d0iM'
      }
    }).toPromise()

    loading.dismiss();
  }

  public GetNowTime() {
    return DateTime.local().setZone("UTC").toSeconds()
  }

}

export interface DmsTask {
  ItemID: string,
  ItemName: string,
  Remarks1: string,
  Remarks2: string,
  Color: string,
  duration?: number,
  code?: string,
  parts?: Part[]
}

export interface DmsCreateJobcardResult {
  response: DmsCreateJobcardResultValue[]
}

export interface DmsCreateJobcardResultValue {
  master_job_no: string;
  job_no_new: string;
  status: string;
  job_details: "S"|"R"
}

export interface DmsUpdateJobcardResult {
  response: DmsUpdateJobcardResultValue[]
}

export interface DmsUpdateJobcardResultValue {
  job_no: string;
  status: string;
}

export interface DmsCarApiResult {
  items: DmsCar[]
}

export interface DmsCar {
  customer_name: string;
  vin: string;
  phonenumber: string;
  brand: string;
  model: string;
  licenseplate: string;
  model_year: string;
  model_group: string;
  vehicle_model_name: string;
  vehicle_model_code: number;
  color: string;
  color_code: string;
  is_recalled: number;
  last_service_km: number;
}